import { IDB_units } from '../IDB/IDB.dexie'
import { updateActiveUnits } from './Unit.sync'

export async function Unit_initialise() {
    const units = await IDB_units().toArray()
    updateActiveUnits(units)
}
